<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      :showChatIdFilter="true"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from 'moment'

const getFullName = (firstName, lastName) => {
  let fullName = ''
  if (firstName) {
    fullName += firstName
  }
  if (lastName) {
    fullName += ' ' + lastName
  }
  return fullName
}

export default {
  name: 'ReferralListPage',
  data () {
    return {
      columnConfig: [
        {
          columnCode: 'fromChatId',
          columnName: 'From ChatId',
          align: 'left',
          value: item => {
            return item.from && item.from.chatId
          }
        },
        {
          columnCode: 'fromName',
          columnName: 'From Name',
          align: 'left',
          value: item => {
            return item.from && getFullName(item.from.firstName, item.from.lastName)
          }
        },
        {
          columnCode: 'toChatId',
          columnName: 'To ChatId',
          align: 'left',
          value: item => {
            return item.to && item.to.chatId
          }
        },
        {
          columnCode: 'toName',
          columnName: 'To Name',
          align: 'left',
          value: item => {
            return item.to && getFullName(item.to.firstName, item.to.lastName)
          }
        },
        {
          columnCode: 'type',
          columnName: 'Type',
          align: 'left',
          value: item => {
            return item.type
          }
        },
        {
          columnCode: 'createdDate',
          columnName: 'Created Date',
          align: 'left',
          value: item => {
            return item.createdDate ? moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          columnCode: 'usedDate',
          columnName: 'Date of use',
          align: 'left',
          value: item => {
            return item.usedDate ? moment(item.usedDate).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          columnCode: 'link',
          columnName: 'Link',
          align: 'left',
          value: item => {
            return item.link
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('referral/list', payload)
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/referral/ReferralListPage.vue